import { render } from "./IconoConBorrar.vue?vue&type=template&id=3e47db6e&scoped=true"
const script = {}

import "./IconoConBorrar.vue?vue&type=style&index=0&id=3e47db6e&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e47db6e"]])

export default __exports__